<template class="transaction">
	<div class="pay">
		<div class="pay_head"></div>
		<div class="pay_main">
			<h6 class="pay_main_text">{{a}}</h6>
			<a class="pay_main_particulars">查看订单详情</a>
			<p class="pay_main_close">
				<span class="pay_main_close_span">本窗口 {{ timerNum }} 秒后自动关闭</span>
			</p>
		</div>
		<div class="pay_foot"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			timer: null, //首先我在data函数里面进行定义定时器名称：
			timerNum: 3, // 设置定时器时间
			a:'',
		};
	},
	mounted() {
		if(this.$route.query.code == 1000){
			this.a = "支付成功,请勿重复支付 !" 
		}else if(this.$route.query.code == 1001){
			this.a = "支付异常" 
		}
		
		this.getStatus();
	},
	methods: {
		getStatus() {
			this.loading(); // 启动定时器
			this.timer = setInterval(() => {
				//创建定时器
				if (this.timerNum === 0) {
					// 设置的定时器时间为0后执行的操作
					this.timer && this.clearTimer(); // 关闭定时器
					// window.open('/', '_blank'); // 在新窗口打开程序员网址导航
					window.close();  //关闭当前页
				} else {
					this.loading();
				}
			}, 1000);
		},
		loading() {
			// 启动定时器
			this.timerNum -= 1; // 定时器减1
			this.text = '获取中(' + this.timerNum + ')';
		},
		clearTimer() {
			//清除定时器
			clearInterval(this.timer);
			this.timer = null;
		}
	},
	// 最后在beforeDestroy()生命周期内清除定时器：
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null;
	}
};
</script>

<style lang="scss" scoped="scoped">
.pay {
	width: 100%;
	height: 100%;
	background-color: #eeeff1;
	.pay_head {
		height: 60px;
	}
	.pay_main {
		margin-top: 200px;
		text-align: center;
		.pay_main_text {
			color: #e50000;
			font-size: 28px;
			line-height: 30px;
		}
		.pay_main_money {
			font-size: 24px;
			margin: 12px 0px;
		}
		.pay_main_particulars {
			display: block;
			width: 120px;
			height: 40px;
			line-height: 40px;
			padding: 0 25px;
			border: 1px solid #4bb1ca;
			color: #4bb1ca;
			border-radius: 3px;
			background: #fff;
			font-size: 14px;
			margin: 0px auto;
			margin-top: 20px;
		}
		.pay_main_close {
			margin-top: 50px;
			font-size: 16px;
			color: #989a99;
			height: 30px;
			border-top: 1px dashed #989a99;
			display: inline-block;
			padding: 0 90px;
			position: relative;
			.pay_main_close_span {
				display: inline-block;
				position: relative;
				top: -11px;
				margin-top: -15px;
				line-height: 28px;
				background: #eeeff1;
				padding: 0 5px;
			}
		}
	}
	.pay_foot {
	}
}
</style>
